
export default function Docs() {
  const styles = {
    content: {
      maxWidth: 800,
      margin: '0 auto',
    },
    section: {
      background: 'rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(10px)',
      borderRadius: 16,
      padding: 32,
      marginBottom: 24,
      border: '1px solid rgba(255, 255, 255, 0.2)',
    },
    title: {
      fontSize: 32,
      fontWeight: 800,
      marginBottom: 24,
    },
    subtitle: {
      fontSize: 24,
      fontWeight: 700,
      marginTop: 32,
      marginBottom: 16,
    },
    text: {
      fontSize: 16,
      lineHeight: 1.8,
      opacity: 0.95,
      marginBottom: 16,
    },
    code: {
      background: 'rgba(0, 0, 0, 0.3)',
      padding: '2px 8px',
      borderRadius: 4,
      fontFamily: 'monospace',
      fontSize: 14,
    },
    list: {
      paddingLeft: 24,
      lineHeight: 1.8,
    },
  };

  return (
    <div style={styles.content}>
      <h1 style={styles.title}>Documentation</h1>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>Getting Started</h2>
        <p style={styles.text}>
          Inbox Sentinel automatically protects your inbox by filtering spam, phishing,
          and low-quality emails before they reach your team.
        </p>
        <p style={styles.text}>
          <strong>Installation Steps:</strong>
        </p>
        <ol style={styles.list}>
          <li>Click "Install Inbox Sentinel" from the home page</li>
          <li>Authorize the required permissions (conversations and contacts)</li>
          <li>Select the location(s) you want to protect</li>
          <li>That's it! Inbox Sentinel starts working immediately</li>
        </ol>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>How It Works</h2>
        <p style={styles.text}>
          Inbox Sentinel operates at the moment an inbound email conversation is created in your CRM:
        </p>
        <ol style={styles.list}>
          <li>Each new email is analyzed using deterministic rules</li>
          <li>Language patterns, link analysis, and sender context are evaluated</li>
          <li>High-confidence spam is automatically removed from the inbox</li>
          <li>Associated spam contacts can be deleted or marked Do Not Contact</li>
          <li>Legitimate emails are left completely untouched</li>
        </ol>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>Required Permissions</h2>
        <p style={styles.text}>
          Inbox Sentinel requires minimal permissions to function:
        </p>
        <ul style={styles.list}>
          <li><code style={styles.code}>conversations.readonly</code> - Read inbox conversations</li>
          <li><code style={styles.code}>conversations.write</code> - Remove spam messages</li>
          <li><code style={styles.code}>contacts.write</code> - Delete or flag spam contacts</li>
          <li><code style={styles.code}>locations.readonly</code> - Access location information</li>
        </ul>
        <p style={styles.text}>
          No other data is accessed, stored, or modified.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>What Gets Filtered</h2>
        <p style={styles.text}>
          Inbox Sentinel removes:
        </p>
        <ul style={styles.list}>
          <li>Romance and social-engineering spam</li>
          <li>Phishing links and tracking URLs</li>
          <li>Automated lead bait and affiliate scams</li>
          <li>Fake contacts that clutter your CRM</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>Customizing AI Detection</h2>
        <p style={styles.text}>
          You can customize the AI spam detection prompt in Settings to adapt it to your specific business needs.
          The prompt includes smart placeholders that are automatically filled with your business information:
        </p>
        <ul style={styles.list}>
          <li><code style={styles.code}>{'{BUSINESS_DOMAINS}'}</code> - Replaced with your business domain (e.g., miltonecom.com)</li>
          <li><code style={styles.code}>{'{BUSINESS_NAME}'}</code> - Replaced with your business name</li>
          <li><code style={styles.code}>{'{BUSINESS_EMAILS}'}</code> - Replaced with your business email addresses</li>
        </ul>
        <p style={styles.text}>
          These placeholders ensure the AI knows which domains and senders are legitimate for your business,
          reducing false positives and improving spam detection accuracy.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>Support</h2>
        <p style={styles.text}>
          Need help? Contact us at:
        </p>
        <p style={styles.text}>
          Email: <a href="mailto:inbox.sentinel@hello.miltonecom.com" style={{ color: '#fff' }}>inbox.sentinel@hello.miltonecom.com</a><br />
          Phone: +18662593033<br />
          Support Site: <a href="/support" style={{ color: '#fff' }}>Inbox Sentinel Support</a>
        </p>
      </div>
    </div>
  );
}
